/**
 *
 * This is the root Vuex store configuration file.
 *
 * Only add data and functions to the root store that apply to the app itself as a whole
 * and need to be visible to all features.
 *
 * *Important: All feature related functions and data must be created in their own
 * feature vuex modules (see `store/admin/system-variables` or `store/tasks`).*
 *
 * @module store/index
 */

export const strict = false;
export * as actions from './actions';
export * as getters from './getters';
export * as mutations from './mutations';
export { state } from './state';

export const namespaced = true;
